import VerticalBarChart from './VerticalBarChart';

export { VerticalBarChart };
export default VerticalBarChart;
